import { Component, inject, Input } from '@angular/core';
import { JsonPipe, NgIf } from '@angular/common';
import { MediaModule } from '@virginmediao2/momentum-angular';
import { SmartFooterModule } from '@virginmediao2/momentum-angular/smart';
import { IMAGE_BASE } from '@/shared/tokens';
import { StrapiInterface } from '@/shared/interfaces/strapi.interface';

@Component({
  selector: 'vm-footer',
  templateUrl: './footer.component.html',
  standalone: true,
  imports: [MediaModule, NgIf, SmartFooterModule, JsonPipe],
})
export class FooterComponent {
  mediaBase = inject(IMAGE_BASE);
  @Input({ required: true }) footer!: StrapiInterface['footer'];
}
